import API from './API';
var WonPrizeService = {
    getWonPrizes: function (config) {
        return API.get('/won_prizes', config);
    }
};
export default WonPrizeService;
